import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export default function EditScopeDialog({ prompt, onChoose, onCancel }) {
  return (
    <Dialog open={!!prompt} onOpenChange={(o) => !o && onCancel()}>
      <DialogContent data-testid="edit-scope-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl">Apply changes to…</DialogTitle>
          <DialogDescription>
            This booking is part of a repeating series with {prompt?.future || 0} upcoming scheduled visit{prompt?.future === 1 ? "" : "s"} after it.
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-3">
          <Button variant="outline" onClick={() => onChoose("one")} data-testid="edit-scope-one" className="h-auto py-4 rounded-xl flex-col items-start text-left">
            <span className="font-medium">This booking only</span>
            <span className="text-xs text-muted-foreground font-normal">Other visits in the series stay as they are.</span>
          </Button>
          <Button onClick={() => onChoose("following")} data-testid="edit-scope-following" className="h-auto py-4 rounded-xl flex-col items-start text-left">
            <span className="font-medium">This and all following bookings</span>
            <span className="text-xs font-normal opacity-80">Copies your changes (time, length, package, price, discount, cleaners, address, notes) to upcoming scheduled visits.</span>
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
